import Intents from '@ux/intents';
const intents = new Intents();
import { getIntents } from '../utils/intents';

const bgColors = {
  'white': {
    backgroundColor: intents.ux.box.backgroundColor,
    color: intents.ux.box.foregroundColor
  },
  'black': {
    backgroundColor: intents.ux.boxHighContrast.backgroundColor,
    color: intents.ux.boxHighContrast.foregroundColor
  },
  'feature': {
    backgroundColor: intents.ux.feedbackInternal.feedbackColor,
    color: intents.ux.feedbackInternal.onFeedbackColor
  },
  'gray': {
    backgroundColor: intents.ux.boxLowContrast.backgroundColor,
    color: intents.ux.boxLowContrast.foregroundColor
  },
  'faint': {
    backgroundColor: intents.ux.boxLowContrast.backgroundColor,
    color: intents.ux.boxLowContrast.foregroundColor
  },
  'warning': {
    backgroundColor: intents.ux.feedbackWarning.feedbackColor,
    color: intents.ux.feedbackWarning.onFeedbackColor
  },
  'info-pastel': {
    backgroundColor: intents.ux.feedbackInfo.feedbackColor,
    color: intents.ux.feedbackInfo.onFeedbackColor
  },
  'primary-midrange': {
    backgroundColor: intents.ux.feedback.feedbackColor,
    color: intents.ux.feedback.onFeedbackColor
  },
  'primary': {
    backgroundColor: intents.ux.feedback.feedbackColor,
    color: intents.ux.feedback.onFeedbackColor
  }
};

export default (props = {}) => {
  const bg = props.bg || props.background;
  const background = {};

  const bgIntent = bgColors[bg]?.backgroundColor || getIntents(bg);
  const fontColorIntent = bgColors[bg]?.color;

  if (bgIntent) background.backgroundColor = bgIntent;
  if (fontColorIntent) background.color = fontColorIntent;
  return (bg && typeof bg  === 'string' && bgIntent) ? background : null;
};



